import React from "react";
import {Heading, List, ListItem, Stack, Text} from "@chakra-ui/react";

export const BlogPost4 = () => {
    return (
        <Stack spacing={3}>
            <Text>Planting a tree, caring for a tree or even removing one could be a tremendous undertaking and because
                trees come with their own complex anatomies and needs, it’s important to consult with a professional
                arborist before making any decisions or changes. Working with a professional can help prevent any
                damage, risks to your property or the people on it and can help foster and environment that is healthy
                and well-suited for your tree.</Text>
            <Heading as="h2" fontSize={'xl'}>Here are some key benefits you’ll experience working with a professional
                arborist:</Heading>
           <List styleType="disc">
                <ListItem>
                    <b>Expert Knowledge:</b> A professional arborist will come equipped with a deep well of knowledge and
                    sense of understanding about trees that you simply can’t dig up on a Google search. A trusted
                    professional can assess a tree and its health and provide accurate diagnoses and treatment plans if
                    necessary. Their expertise allows them to identify issues that may not be immediately apparent and
                    recommend the most effective course of action to ensure the health and longevity of your trees.
                </ListItem>
                <ListItem>
                    <b>Safety & Security:</b> Working with a tree comes with risks: some more obvious than others. A
                    branch might snap, foliage might fall, and you could run into an unexpected infestation. That said, a
                    trained arborist will have the right training and proper equipment to handle the job safely and
                    efficiently. They follow strict safety protocols to minimize risks to themselves, your property, and
                    anyone nearby, ensuring that the tree work is carried out without incident.
                </ListItem>
                <ListItem>
                    <b>Preventative Care:</b> Just as it is important to maintain our own health and catch things before
                    they spread, it is paramount to take preventative actions when it comes to tree health. A trained
                    arborist can point out signs and identify potential diseases before they become overwhelming, saving
                    homeowners work and money down the road. By addressing issues early and implementing preventive
                    measures, such as proper pruning and fertilization, they help maintain the overall health and vigor of
                    your trees, reducing the risk of costly problems in the future.
                </ListItem>
                <ListItem>
                    <b>Value:</b> Keeping your trees and property pristine is one of the best ways to add to your
                    property’s value. Working with an arborist is an investment well made. Properly maintained trees not
                    only enhance the aesthetic appeal of your landscape but also contribute to the overall value of your
                    property. An arborist’s expertise ensures that your trees remain healthy, vibrant, and structurally
                    sound, increasing their longevity and enhancing your property’s curb appeal.
                </ListItem>
            </List>

            <Text>Our thoroughly-trained team at Overland Park Tree Care comes with years of experience that we love to
                share with the community. We are here to address all of your tree care needs! Contact us today for a
                consultation.</Text>
        </Stack>
    )
}